module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/atlanta-91415d66851175129f889d27f9f568a4.jpg";